<!-- ========================================================================================
      Author: Alizadeh
========================================================================================== -->

<!-- <template src="./Bills.html">-->
<template>
  <vs-popup
    class="holamundo"
    popup-class="w-9/12"
    :title="`انتخاب قالب کارمزد &quot;` + shopName + `&quot;`"
    :active.sync="popupActive"
  >
    <vx-card class="mb-2">
      <vs-table
        id="tbl2"
        ref="tbl2"
        :data="items"
        class="table-dark-inverted"
        search
        max-items="10"
        pagination
      >
        <template slot="thead">
          <vs-th>ردیف</vs-th>
          <vs-th sort-key="name">نام</vs-th>
          <vs-th></vs-th>
          <vs-th></vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <span>{{ indextr + 1 }}</span>
            </vs-td>
            <vs-td :data="tr.groupName">
              <span>{{ tr.groupName }}</span>
            </vs-td>
            <vs-td>
              <feather-icon
                v-if="merchantCommissionGroupId == tr.id"
                strokeWidth="2"
                title="پیشفرض"
                icon="CheckCircleIcon"
                svgClasses="h-6 w-6 text-success"
              ></feather-icon>
            </vs-td>
            <vs-td>
              <vs-button
                v-if="merchantCommissionGroupId == tr.id"
                color="primary"
                type="flat"
                @click="deselect()"
                >لغو</vs-button
              >
              <vs-button
                v-else
                color="primary"
                type="flat"
                @click="select(tr.id)"
                >انتخاب</vs-button
              >
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>
    <!-- <commissions ref="CommissionsOfGroup" @success="fillTable"></commissions> -->
  </vs-popup>
</template>
<style>
</style>
<script>
// import Commissions from "./Commissions.vue";
export default {
  name: "select-commission-group",
  props: {},
  components: {
    // Commissions
  },
  data() {
    return {
      popupActive: false,
      items: [],
      shopName: "",
      shopId: null,
      merchantCommissionGroupId: null,
    };
  },
  methods: {
    show(shopId, shopName = "") {
      this.items = [];
      if (shopId) {
        this.shopId = shopId;
        this.shopName = shopName;
        this.fillTable();
        this.popupActive = true;
      }
    },
    fillTable() {
      let loading = this.$vs.loading();
      this.$http
        .get(
          `/api/services/app/CustomSettingGroup/GetMerchantCustomSettins?id=${this.shopId}`
        )
        .then((response) => {
          this.items = response.data.result.items;
          this.merchantCommissionGroupId =
            response.data.result.selectedId ;
          this.$vs.loading.close();
        }) //end success
        .catch((error) => {
          console.log(error);
          this.$vs.loading.close();
        }); //end http
    },
    clear() {
      this.filter = "";
    },
    SetPageSize(val) {
      this.pageSize = val;
      this.pageNo = 1;
      this.fillTable();
    },
    showCommisions(id, name) {
      this.$router.push({
        name: "Commissions",
        params: {
          commissionGroupId: id,
        },
      });
      //this.$refs.CommissionsOfGroup.show(id, name);
    },
    select(commisssionGroupId) {
      let loading = this.$vs.loading();

      let payload = {
        shopId: this.shopId,
        CustomSettingGroupId: commisssionGroupId,
      };
      this.$http
        .post(
          `/api/services/app/CustomSettingGroup/AssignCustomSettingGroupToMerchant`,
          payload
        )
        .then((response) => {
          if (response.data.success) {
            this.$vs.notify({
              time: 5000,
              color: "success",
              title: "موفق!",
              text: "قالب با موفقیت انتصاب شد",
            });
            this.fillTable();
            //this.popupActive = false;
          }
          this.$vs.loading.close();
        }) //end success
        .catch((error) => {
          console.log(error);
          this.$vs.loading.close();
        });
    },
    deselect() {
      let loading = this.$vs.loading();

      let payload = {
        params: {
          id: this.shopId,
        },
      };
      this.$http
        .delete(
          `/api/services/app/CustomSettingGroup/RemoveCustomSettingGroupFromMerchant`,
          payload
        )
        .then((response) => {
          if (response.data.success) {
            this.$vs.notify({
              time: 5000,
              color: "success",
              title: "موفق!",
              text: "قالب با موفقیت لغو شد",
            });
            this.fillTable();
            //this.popupActive = false;
          }
          this.$vs.loading.close();
        }) //end success
        .catch((error) => {
          console.log(error);
          this.$vs.loading.close();
        });
    },
  },
};
</script>
